import { inheritsLoose as _inheritsLoose } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

var _class;
var Line = withTheme((_class = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(Line, _PureComponent);
  function Line() {
    return _PureComponent.apply(this, arguments) || this;
  }
  var _proto = Line.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      path = _this$props.path,
      stroke = _this$props.stroke,
      strokeWidth = _this$props.strokeWidth,
      fill = _this$props.fill,
      className = _this$props.className,
      theme = _this$props.theme;
    return /*#__PURE__*/React.createElement("path", {
      d: path,
      stroke: stroke || theme.constellation.colors.blue500,
      strokeWidth: strokeWidth,
      fill: fill,
      className: className
    });
  };
  return Line;
}(PureComponent), _class.propTypes = {
  className: PropTypes.string,
  fill: PropTypes.string,
  path: PropTypes.string.isRequired,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
  theme: PropTypes.object
}, _class.defaultProps = {
  strokeWidth: 1.5,
  fill: 'none',
  className: 'rd3-linechart-path'
}, _class));

export { Line as default };
